import { observable } from "mobx";
import { api } from "../../api";
import {
  IEmpresa,
  IReceita,
  newEmpresa,
  newIReceita,
} from "../../model";
import { toast } from "react-toastify";
import { AppStore } from "../AppStore";
import { nameFile } from "../../utils";
import { LookupStore } from "../LookupStore";

export class _DaeAvulsoStore {
  obs = observable({
    loading_erros: false as boolean,
    tasks_dae_avulso: [] as any[],
    tasks_dae_length: 0 as number,
    loading_tasks: false as boolean,
    selectEmpresaDae: newEmpresa() as IEmpresa,
    selectedPeriodDae: [] as any,
    loading_arquivos: false as boolean,
    loadingArquivoAll: false as boolean,
    loadingDetalhes: false as boolean,
    loadingViewArquivo: false as boolean,

    selectedEmpresa: newEmpresa() as IEmpresa,
    date_start: "" as string,
    date_end: "" as string,
    modelo: "NF-E" as string,
    tipo: "Entrada" as string,

    selectedPeriod: [] as any,
    summary: [] as any,

    isResultados: false,

    open_dae_avulso: false as boolean,
    receita: newIReceita() as IReceita,
    date_calculo: null as Date,
    date_vencimento: null as Date,

  })

  async handleSolicitaDAE(dados) {

    try {

      let params = {
        codigo_receita: dados.codigo_receita,
        data_calculo: dados.data_calculo,
        cnpj: dados.cnpj,
        data_vencimento: dados.data_vencimento,
        data_referencia: dados.data_referencia,
        documento_origem: dados.documento_origem,
        valor_pagar: Math.abs(dados.valor_pagar),
        informacao_adicional: dados.informacao_adicional || "",
        dae_new: AppStore.obs1.usuario.conta.dae_new || false
      }

      let resp = await api.post('/api/dae-avulso-transmite', params)

      if (resp.data.ok) {

        toast.success('Solicitação DAE realizada com sucesso!', {});

      } else {

        if (resp.data.error) {

          toast.error(resp.data.error, {});

        } else {

          const errorFields = Object.keys(resp.data.erros);

          errorFields.forEach(field => {

            const errorMessage = resp.data.erros[field][0];

            toast.error(errorMessage, {});

          });

        }

      }

    } catch (ex) {

      toast.error("Erro ao solicitar DAE, tente novamente mais tarde!", {});

    }

  }

  async consultaErro(_id: string) {

    console.log("_id", _id)

    try {

      let resp = await api.post(`/api/consulta-erro-tarefa`, { _id: _id });

      if (resp.data.length > 0) {
        return resp.data;
      } else {
        return []
      }
    } catch (ex) {
      toast.error('Erro ao consultar Erro Tarefa, tente novamente mais tarde.', {});
    }
    return []
  }

  async handleDaePaged(paged: number, cnpj: string, data_start: string, data_end: string, tipo?: "simples" | "dae_avulso") {
  this.obs.loading_tasks = true;

  if (!cnpj) {
    toast.warn("Selecione uma empresa para a consulta.");
    this.obs.loading_tasks = false;
    return;
  }

  if (!data_start || !data_end || data_end == "Data inválida" || data_start == "Data inválida") {
    toast.warn("Selecione o período da consulta.");
    this.obs.loading_tasks = false;
    return;
  }

  try {
    let data = {
      page: paged,
      limit: 15,
      cnpj: cnpj,
      data1: data_start,
      data2: data_end,
      tipo: tipo
    }

    let resp = await api.post("/api/dae-avulso-consulta-lote", data);

    this.obs.tasks_dae_avulso = [];
    this.obs.tasks_dae_length = 0;

    if (resp.data) {

      let itens = resp.data.itens;

      if (tipo) {
        itens = itens.filter(task => task.tipo === tipo);
      }

      this.obs.tasks_dae_length = itens.length;
      this.obs.tasks_dae_avulso = itens;

    } else {
      toast.warn('Nenhum detalhe para exibir.', {});
    }

  } catch (ex) {
    toast.error('Erro ao consultar Erro Tarefa, tente novamente mais tarde.', {});
  }

  this.obs.loading_tasks = false;
}


  async downloadArquivosAll(uuid: string, cnpj: string) {
    this.obs.loadingArquivoAll = true
    try {
      let req = { uuid: uuid };

      let resp = await api.post(`/api/download-todas-transmissoes`, req);

      const linkSource = `data:application/zip;base64,${resp.data}`;
      const downloadLink = document.createElement("a");
      let fileName = "arquivos_dae_" + cnpj + ".zip";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

    } catch (ex) {
      toast.error('Erro ao realizar download Transmissões, tente novamente mais tarde.', {});
    }
    this.obs.loadingArquivoAll = false
  }

  async downloadArquivoNivy(uuid: string, nome: string, id: number) {
    this.obs.loading_arquivos = true;

    try {

      let req = { uuid: uuid, file_id: id };

      let resp = await api.post(`/api/download-transmissao`, req);

      this.download_pdf(resp.data, nome)

    } catch (ex) {
      toast.error('Erro ao realizar download DAE, tente novamente mais tarde.', {});
    }

    this.obs.loading_arquivos = false

  }

  async downloadArquivo(empresa: IEmpresa, task_id: number) {

    this.obs.loading_arquivos = true;

    try {

      let nome = nameFile(empresa, "DAE-AVULSO");

      let params = {
        task_id: task_id,
      }

      let resp = await api.post(`/api/dae-avulso/download`, params);

      if (resp.data.ok) {

        this.download_pdf(resp.data.base64, nome)

      } else {

        toast.error('Não foi possível realizar download do DAE, tente novamente mais tarde.', {});

      }

    } catch (ex) {

      toast.error('Erro ao realizar download DAE, tente novamente mais tarde.', {});

    }

    this.obs.loading_arquivos = false

  }

  download_pdf(resp, nome) {

    const linkSource = `data:application/pdf;base64,${resp}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = nome
    downloadLink.click();

  }

  async consultaArquivo(uuid: string) {

    this.obs.loadingDetalhes = true

    try {
      let req = { uuid: uuid };

      let resp = await api.post(`/api/consulta-arquivo-tarefa`, req);

      return resp.data;

    } catch (ex) {
      toast.error('Erro ao consultar Arquivo Tarefa DAE, tente novamente mais tarde.', {});
      return []
    }
  }

  formatter_valores(resp) {
      return resp.data.summary?.flatMap((value) => {
  
        const classificacao = LookupStore.getIcmsClassificacaoDAE(value.icms_classificacao_id);
  
        const itens = []
  
        if (classificacao) {
  
          if (value.valor_icms > 0) {
            itens.push({
              ...value,
              campo: "ICMS",
              outros_debitos: [{ nome: "ICMS", valor: value.valor_icms }, { nome: "FCP", valor: 0 }, { nome: "ICMS 1139", valor: 0 }],
              name: classificacao?.nome + " - ICMS",
              dae_avulso: classificacao?.dae_avulso ?? false,
              dei: classificacao?.dei ?? false,
              codigo_receita: classificacao?.codigo_receita ?? "",
            })
          }
  
          if (value.valor_fcp > 0) {
            itens.push({
              ...value,
              campo: "FCP",
              outros_debitos: [{ nome: "ICMS", valor: 0 }, { nome: "FCP", valor: value.valor_fcp }, { nome: "ICMS 1139", valor: 0 }],
              name: classificacao?.nome + " - FCP",
              dae_avulso: classificacao?.dae_avulso ?? false,
              dei: classificacao?.dei ?? false,
              codigo_receita: classificacao?.codigo_receita ?? "",
            })
          }
  
          if (value.valor_1139 > 0) {
            itens.push({
              ...value,
              campo: "1139",
              outros_debitos: [{ nome: "ICMS", valor: 0 }, { nome: "FCP", valor: 0 }, { nome: "ICMS 1139", valor: value.valor_1139 }],
              name: classificacao?.nome + " - ICMS 1139",
              dae_avulso: classificacao?.dae_avulso ?? false,
              dei: classificacao?.dei ?? false,
              codigo_receita: classificacao?.codigo_receita ?? "",
            })
          }
  
        }
  
        return itens
  
      });
    }
}

export const DaeAvulsoStore = new _DaeAvulsoStore();
